import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  createWarehouse,
  updateWarehouse,
  getBranch,
  apiClient,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import { WarehouseContext } from "../../../Utility/UserContext";

const WarehouseForm = ({ warehouse, closeModal, refreshList }) => {
  const { showLoader, hideLoader, shopItem, UserItem } =useContext(WarehouseContext);

  const [formData, setFormData] = useState({
    title: "",
    branch: "",
    address: "",
    latitude: "",
    longitude: "",
    image: "",
    email: "",
    phone: "",
    status: "1",
    shop_id: shopItem?.shop_id || "0",
    created_by: UserItem?.user_id || "0",
  });
  
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [errors, setErrors] = useState({});
  const [branch, setBranchs] = useState([]);

  useEffect(() => {
    fetchBranchs();
    if (warehouse) {
      setFormData({
        title: warehouse.title,
        branch: warehouse.branch,
        address: warehouse.address,
        shop_id: shopItem?.shop_id || "0",
        created_by: UserItem?.user_id || "0",
        latitude: warehouse.latitude,
        longitude: warehouse.longitude,
        email: warehouse.email,
        phone: warehouse.phone,
        status: warehouse.status.toString(),
        image: warehouse.image
          ? apiClient.defaults.baseURL + warehouse.image // Append baseURL to image path
          : "",
      });
    }
  }, [warehouse]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    

    if (name === "phone") {
      // Restrict phone field to numeric values
      const numericValue = value.replace(/\D/g, "");
      setFormData((prevState) => ({
        ...prevState,
        [name]: numericValue,
      }));
      if (numericValue.length === 0) {
        setPhoneError("Phone number is required");
      } else if (numericValue.length < 8) {
        setPhoneError("Phone number must be at least 8 digits long");
      } else {
        setPhoneError(""); // Clear error if valid
      }

      //  setPhoneError(numericValue.length === 0 ? 'Phone number is required' : '');
    } else if (name === "email") {
      // Validate email format
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setEmailError(emailRegex.test(value) ? "" : "Invalid email format");
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setErrors((prev) => ({
        ...prev,
        [name]: "", // Clear error when user makes a change
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader();

    // Check for validation errors before submission
    if (emailError || phoneError || !formData.email || !formData.phone) {
      toast.error("Please fix the errors before submitting");
      handleSubmit();
      emailError.emailError = "Email Error is required.";

      return;
    }

    const formDataPayload = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "image" && formData[key] instanceof File) {
        formDataPayload.append(key, formData[key]);
      } else if (key !== "image") {
        formDataPayload.append(key, formData[key]);
      }
    });
    formDataPayload.append("branch", "0");
    formDataPayload.append("status", formData.status === "1" ? 1 : 0);

    try {
      if (warehouse) {
        await updateWarehouse(warehouse.id, formDataPayload);
        hideLoader();
        toast.success("Warehouse updated successfully");
      } else {
        await createWarehouse(formDataPayload);
        hideLoader();
        toast.success("Warehouse added successfully");
      }
      closeModal();
      // window.location.reload();
await refreshList();
    } catch (error) {
      console.log('error',error.response.data.errors.email[0]);
      console.error("Error saving warehouse data:", error);
      hideLoader();
      toast.error(error?.response?.data?.errors?.email[0]);
    }
  };

  const fetchBranchs = useCallback(async (page = 1, text = "") => {
    try {
      const response = await getBranch();
      if (response.data?.data) {
        setBranchs(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
              {warehouse ? "Edit Warehouse" : "Add Warehouse"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body" style={{ fontFamily: "poppins" }}>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              {[
                "title",
                // "branch",
                "address",
                // "latitude",
                // "longitude",
                "email",
                "phone",
              ].map((field) => (
                <div className="form-group mb-3" key={field}>
                  <label>
                    {field === "title"
                      ? "Name"
                      : field.charAt(0).toUpperCase() + field.slice(1)}
                  </label>
                  {field === "branch" ? (
                    <select
                      name={field}
                      value={formData[field]}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select Branch</option>
                      {branch.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={
                        field === "email"
                          ? "email"
                          : field === "phone"
                            ? "text"
                            : "text"
                      }
                      name={field}
                      value={formData[field]}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  )}
                  {field === "email" && emailError && (
                    <small className="text-danger">{emailError}</small>
                  )}
                  {field === "phone" && phoneError && (
                    <small className="text-danger">{phoneError}</small>
                  )}
                </div>
              ))}
              <div className="form-group mb-3">
                <label>Image</label>
                {warehouse && formData.image != null && (
                  <div>
                    <img
                      src={formData.image}
                      alt="Warehouse"
                      className="img-thumbnail mb-2"
                      width="100"
                      height="100"
                    />
                  </div>
                )}

                <input
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={(e) =>
                    setFormData((prevState) => ({
                      ...prevState,
                      image: e.target.files[0],
                    }))
                  }
                  className="form-control"
                />
              </div>

              <button type="submit" className="btn btn-success float-end">
                {warehouse ? "Update Warehouse" : "Add Warehouse"}
              </button>
              <button
                type="button"
                className="btn btn-secondary ml-2 float-end me-1"
                onClick={closeModal}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarehouseForm;
